import { Component, OnInit } from '@angular/core';
import { TransportorsService } from 'src/app/services/transportors/transportors.service';

@Component({
  selector: 'app-add-commercial',
  templateUrl: './add-commercial.component.html',
  styleUrls: ['./add-commercial.component.css']
})
export class AddCommercialComponent implements OnInit {

  imageUrl: string = '';
  fileToUpload: File = null;

  constructor(private transServices: TransportorsService) { }

  ngOnInit(): void {
  }

  addCommercial(code, firstName, lastName, username, numTel) {
    if (firstName.value != "" && lastName.value != "" && username.value.includes('@')
      && username.value != "" /*&& this.imageUrl != ""*/ && code.value != '' 
      && numTel.value != "" && numTel.value.length == 8) {

      const formData: any = new FormData();
      
      if(this.fileToUpload != null) {
        formData.append("profile", this.fileToUpload, this.fileToUpload['name']);
      }

      var commercial = {
        code: code.value,
        nom: lastName.value,
        prenom: firstName.value,
        numtel: numTel.value,
        username: username.value
      }
      for (var key in commercial) {
        formData.append(key, commercial[key]);
      }

      // if (true) {
      if (confirm('Etes vous sûre?')) {
        this.transServices.addCommercial(formData).then((res: any) => {
          // console.log("ressssss add cat : ")
          // console.log(res)
          if (res == true) {
            location.href = '/commercial-transportors';
          } else {
            alert(res.msg);
          }
        });
      }
    } else {
      alert('Les données de la société est invalide');
    }
  }

  handleFileInput(file: FileList) {
    this.fileToUpload = file.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageUrl = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }

}
